import "../sass/app.scss";

import CarouselHeroCaption from "./modules/CarouselHeroCaption";
import CarouselHeroImages from "./modules/CarouselHeroImages";
import TransparentHeader from "./modules/TransparentHeader";
import ThreeSlidesTextCarousel from "./modules/ThreeSlidesTextCarousel";
import Animations from "./modules/Animations";
import CarouselThreeImages from "./modules/CarouselThreeImages";
import CarouselImageFullWidth from "./modules/CarouselImageFullWidth";
import CarouselTestimonials from "./modules/CarouselTestimonials";
import CarouselOnePictureMargins from "./modules/CarouselOnePictureMargins";
import CollapseMobileMenu from "./modules/CollapseMobileMenu";
import GravityFormScroll from "./modules/GravityFormScroll";
import DynamicScrollHeader from "./modules/DynamicScrollHeader";
import TabbedContentBlock from "./modules/TabbedContentBlock";
import ServicesShowcaseBlock from "./modules/ServicesShowcaseBlock";
import RelatedArticlesCarousel from "./modules/RelatedArticlesCarousel";
import LightboxModal from "./modules/LightboxModal";

// const threeSlideCarousel = new ThreeSlideCarousel();
const carouselHeroCaption = new CarouselHeroCaption();
const carouselHeroImages = new CarouselHeroImages();
const transparentHeader = new TransparentHeader();
const threeSlidesTextCarosel = new ThreeSlidesTextCarousel();
const animations = new Animations();
const carouselThreeImages = new CarouselThreeImages();
const carouselImageFullWidth = new CarouselImageFullWidth();
const carouselTestimonials = new CarouselTestimonials();
const carouselOnePictureMargins = new CarouselOnePictureMargins();
const collapseMobileMenu = new CollapseMobileMenu();
const gravityFormScroll = new GravityFormScroll();
const dynamicScrollHeader = new DynamicScrollHeader();
const tabbedContentBlock = new TabbedContentBlock();
const servicesShowcaseBlock = new ServicesShowcaseBlock();
const relatedArticlesCarousel = new RelatedArticlesCarousel();
const lightboxModal = new LightboxModal();
